module.exports = __webpack_public_path__ + "static/media/test16_6.68a0781f.png";